//采购商企业导航菜单
export default [

    {label:'业务管理',iconClass:'icon-yewu',powerArr:[221,261,365,433,431,138,107,546],path:{name:'OrderLists',query:{page:1,orderStatus:'all',orderType:3}},num:'order'},
    {label:'财务管理',iconClass:'icon-caiwuguanli',powerArr:[152,268,367,231,554,555],path:{name:'FinancialList'},num:'treasurer_count'},
    {label:'人事管理',
        iconClass:'icon-renshiguanli',
        powerArr:[],
        children:[
            {label:'销售列表',powerArr:[332,175,288,387,581],path:{name:'LinkedList'}},
            {label:'申请列表',powerArr:[337,170,293,392,582],path:{name:'PersonnelList'}},
        ],
    },
    {label:'资料信息',
    iconClass:'icon-Information',
        children:[
            {label:'门店资料',powerArr:[152,268,367,231,554,555],path:{name:'StoreCertification'}},
            {label:'企业资质',powerArr:[152,268,367,231,554,555],path:{name:'Corporateimages'}},
            {label:'银行卡管理',powerArr:[152,268,367,231,554,555],path:{name:'BankcardManage'}},
            // {label:'导游管理',powerArr:[243],path:{name:'IncomeDetail'}},
        ],
        path:{name:'InfoManage'}
    },
    // {label:'积分明细',iconClass:'icon-jifen',powerArr:[],path:{name:'GradeManage'}},
    // {label:'消息中心',iconClass:'icon-xiaoxi',powerArr:[],path:{name:'MsgLists',query:{msg_type:'2'}}},
    {label:'账号设置',iconClass:'icon-shezhi',powerArr:[],path:{name:'AccountSet'}}
]